/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1TOSAgreement } from '../models/V1TOSAgreement';
import { HttpFile } from '../http/http';

/**
* response to Download a TOS file.
*/
export class V1ListTOSAgreementsResponse {
    /**
    * List of all tos agreements
    */
    'tosAgreements'?: Array<V1TOSAgreement>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "tosAgreements",
            "baseName": "tos_agreements",
            "type": "Array<V1TOSAgreement>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1ListTOSAgreementsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

